import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LeadsStatusesDatabaseContext from "@/modules/leads_statuses/contexts/LeadsStatusesDatabaseContext";
import Paper from '@/modules/common/components/Paper';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import Websocket from '@/modules/common/components/Websocket';
import ErrorFetch from "@/modules/common/components/ErrorFetch";
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import { actionDockSetExpandLeadsStatuses } from '@/modules/application/actions/dock';
import { formatDate, parseDate } from '~/common';
import Top from './Top';
import Table from './Table/Table';
import '../../styles/LeadsStatusesDatabase.scss';

const initialValuesFilter = {
    ids: '',
    advSub: '',
    offerName: [],
    dateLead: {from: null, to: null},
    vacancy: [],
    city: '',
    status1: [],
    status2: [],
    status3: [],
    date: {from: null, to: null},
};

const mapValuesFilter = {
    ids: 'ids',
    advSub: 'adv_sub',
    offerName: 'offer_name',
    vacancy: 'vacancy',
    city: 'city',
    status1: 'status1',
    status2: 'status2',
    status3: 'status3',
};

function isFiltered(urlSearchParams) {
    return (
        Object.entries(mapValuesFilter).some((element) => urlSearchParams.get(element[1])) ||
        urlSearchParams.get('date_lead_from') ||
        urlSearchParams.get('date_lead_to') ||
        urlSearchParams.get('date_from') ||
        urlSearchParams.get('date_to')
    );
}

let abortController;

const LeadsStatusesDatabase = (props) => {
    const breadcrumbs = [
        {name: 'Статусы'},
        {name: 'База данных'},
    ];

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [valuesFilter, setValuesFilter] = useState(initialValuesFilter);
    const [offers, setOffers] = useState([]);
    const [vacancies, setVacancies] = useState([]);
    const [statuses1, setStatuses1] = useState([]);
    const [statuses2, setStatuses2] = useState([]);
    const [statuses3, setStatuses3] = useState([]);

    const fetch = () => {
        if (abortController) {
            abortController.abort();
        }
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/leads_statuses/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    useEffect(() => {
        props.dockSetExpandLeadsStatuses(true);
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));
        const dateLeadFrom = parseDate(props.router.getUrlSearchParam('date_lead_from'), 'dd.MM.yy');
        const dateLeadTo = parseDate(props.router.getUrlSearchParam('date_lead_to'), 'dd.MM.yy');
        const dateFrom = parseDate(props.router.getUrlSearchParam('date_from'), 'dd.MM.yy');
        const dateTo = parseDate(props.router.getUrlSearchParam('date_to'), 'dd.MM.yy');


        let _valuesFilter = {...initialValuesFilter};
        Object.entries(mapValuesFilter).forEach((element) => {
            _valuesFilter[element[0]] = props.router.getUrlSearchParam(element[1]);
        });
        _valuesFilter.offerName = props.router.getUrlSearchParam('offer_name').split('||');
        _valuesFilter.dateLead = {from: dateLeadFrom, to: dateLeadTo};
        _valuesFilter.vacancy = props.router.getUrlSearchParam('vacancy').split('||');
        _valuesFilter.status1 = props.router.getUrlSearchParam('status1').split('||');
        _valuesFilter.status2 = props.router.getUrlSearchParam('status2').split('||');
        _valuesFilter.status3 = props.router.getUrlSearchParam('status3').split('||');
        _valuesFilter.date = {from: dateFrom, to: dateTo};
        setValuesFilter(_valuesFilter);

        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);

        fetch();
    }, [props.history.location.search]);

    const handleClickResetFilter = () => {
        props.history.push({search: '?page=1'});
    };

    const handleSubmitFilter = (event) => {
        event.preventDefault();
        Object.entries(mapValuesFilter).forEach((element) => {
            props.router.urlSearchParams.set(element[1], valuesFilter[element[0]]);
        });
        props.router.urlSearchParams.set('offer_name', valuesFilter.offerName.join('||'));
        props.router.urlSearchParams.set('date_lead_from', formatDate(valuesFilter.dateLead.from));
        props.router.urlSearchParams.set('date_lead_to', formatDate(valuesFilter.dateLead.to));
        props.router.urlSearchParams.set('vacancy', valuesFilter.vacancy.join('||'));
        props.router.urlSearchParams.set('status1', valuesFilter.status1.join('||'));
        props.router.urlSearchParams.set('status2', valuesFilter.status2.join('||'));
        props.router.urlSearchParams.set('status3', valuesFilter.status3.join('||'));
        props.router.urlSearchParams.set('date_from', formatDate(valuesFilter.date.from));
        props.router.urlSearchParams.set('date_to', formatDate(valuesFilter.date.to));
        props.router.urlSearchParams.set('page', '1');
        props.history.push({search: props.router.urlSearchParams.toString()});
    };

    // noinspection JSUnresolvedVariable
    return (
        <LeadsStatusesDatabaseContext.Provider value={{
            valuesFilter: valuesFilter, setValuesFilter: setValuesFilter,
            offers: offers, vacancies: vacancies,
            statuses1: statuses1, statuses2: statuses2, statuses3: statuses3,
        }}>
            <Content id="leads_statuses-database">
                <ContentHeader breadcrumbs={breadcrumbs}/>
                <ContentBody><Paper>
                    {(!loading)
                        ? <>
                            {(data && data.results)
                                ? <>
                                    <Top leadsStatuses={data.results}
                                         isFiltered={Boolean(isFiltered(props.router.urlSearchParams))}
                                         onClickResetFilter={handleClickResetFilter}
                                         onSubmitFilter={handleSubmitFilter}
                                    />
                                    <Table items={data.results}/>
                                    {(data.results.length > 0)
                                        ? <>
                                            <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                        </>
                                        : null
                                    }
                                </>
                                : <ErrorFetch onClick={() => fetch()}/>
                            }
                        </>
                        : <Spinner/>
                    }
                    <Websocket path={`/ws/leads_statuses/data/?offer_name=${props.router.getUrlSearchParam('offer_name')}`}
                               onMessage={(data) => {
                                   data = JSON.parse(data);
                                   setOffers(data.offers);
                                   setVacancies(data.vacancies);
                                   setStatuses1(data.statuses1);
                                   setStatuses2(data.statuses2);
                                   setStatuses3(data.statuses3);
                               }}
                    />
                </Paper></ContentBody>
            </Content>
        </LeadsStatusesDatabaseContext.Provider>
    );
};

let Component = LeadsStatusesDatabase;
Component = withRouter(Component);
Component = withFetch(Component);

export default connect(
    null,
    (dispatch) => ({
        dockSetExpandLeadsStatuses: bindActionCreators(actionDockSetExpandLeadsStatuses, dispatch),
    })
)(Component);
